import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useMenu } from 'contexts/MenuContext'
import { DcDiv } from 'pixel-base'
import styled from 'styled-components'
import AccountCardIcon from 'utils/icons/account-card-icon'
import ChevronDownIcon from 'utils/icons/chevron-down-icon'
import HistoryIcon from 'utils/icons/history-icon'

import {
  AnalyticsIcon,
  CustomersIcon,
  LocationsIcon,
  OrdersIcon,
  PaymentsIcon,
  ProductsInventoryIcon,
  SettingsIcon,
} from 'utils/icons/icon'
import { ManufacturingIcon } from 'utils/icons/manufacturing-icon'

import TicketStubIcon from 'utils/icons/ticket-stub-icon'

interface MenuItemProps {
  activeMenu: string
  menu: {
    name: string
    route: string
    permissions_required?: string
    children?: Array<{
      name: string
      route: string
      permissions_required?: string
    }>
  }
  setActiveRoute: (_route: string) => void
}

const MenuItem: React.FC<MenuItemProps> = ({
  activeMenu,
  menu,
  setActiveRoute,
}) => {
  const { isCollapsed, isHovered } = useMenu()
  const location = useLocation()
  const [isOpen, setIsOpen] = React.useState(
    `/${activeMenu.split('/')[1]}` === menu.route,
  )

  const [isActive, setIsActive] = React.useState(
    `/${activeMenu.split('/')[1]}` === menu.route,
  )
  const navigate = useNavigate()

  useEffect(() => {
    const active = location.pathname.startsWith(menu.route)
    setIsActive(active)

    const shouldBeOpen =
      (active && !isCollapsed) ||
      (location.pathname.includes(menu.route) && isHovered) ||
      (`/${activeMenu.split('/')[1]}` === menu.route &&
        !isCollapsed &&
        !isHovered)

    if (
      (isCollapsed && isHovered) ||
      (isCollapsed && activeMenu.split('/').length >= 3) ||
      (menu.children && menu.children.length > 0)
    ) {
      setIsOpen(false)
    } else {
      setIsOpen(shouldBeOpen)
    }
  }, [location.pathname, menu.route, isCollapsed, isHovered, activeMenu])

  const handleClick = (subMenuItem?) => {
    setActiveRoute(subMenuItem ? subMenuItem : menu.route)
    navigate(subMenuItem ? subMenuItem : menu.route)
  }

  const menuIcon = React.useMemo(() => {
    return menu.name === 'Locations' ? (
      <LocationsIcon />
    ) : menu.name === 'Orders' ? (
      <OrdersIcon />
    ) : menu.name === 'Payments' ? (
      <PaymentsIcon />
    ) : menu.name === 'Customers' ? (
      <CustomersIcon />
    ) : menu.name === 'Products & Inventory' ? (
      <ProductsInventoryIcon />
    ) : menu.name === 'Settings' ? (
      <SettingsIcon />
    ) : menu.name === 'Analytics' ? (
      <AnalyticsIcon />
    ) : menu.name === 'Finance' ? (
      <AccountCardIcon />
    ) : menu.name === 'Tickets' ? (
      <TicketStubIcon />
    ) : menu.name === 'Production Planning' ? (
      <ManufacturingIcon color="rgba(255, 255, 255, 0.904)" size={20} />
    ) : (
      <HistoryIcon />
    )
  }, [menu.name])
  return (
    <MenuItemContainer isActive={isActive}>
      <MenuLink
        onClick={() => {
          handleClick(menu.route)
          setIsOpen(!isOpen)
        }}
      >
        <DcDiv style={{ width: '24px', marginRight: '12px' }}>{menuIcon}</DcDiv>
        {(!isCollapsed || !isHovered) && (
          <DcDiv
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              width: ' 100%',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              fontSize: '0.875rem',
              color: '#f8f8f9',
              opacity: 0.9,
            }}
          >
            {menu.name}
          </DcDiv>
        )}
        {menu.children &&
          menu.children.length > 1 &&
          (!isCollapsed || !isHovered) && (
            <DcDiv
              style={{
                marginLeft: 'auto',
                transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                transition: 'transform 0.2s ease',
              }}
            >
              <ChevronDownIcon color={'#f8f8f9df'} size={16} />
            </DcDiv>
          )}
      </MenuLink>
      {(!isCollapsed || !isHovered) &&
        (isOpen || location.pathname.includes(menu.route)) &&
        menu.children &&
        menu.children.length >= 2 && (
          <SubMenu>
            {menu.children.map((subMenu) => (
              <SubMenuItem
                key={subMenu.route}
                className={`${
                  location.pathname === subMenu.route && 'isActive'
                }`}
                onClick={() => handleClick(subMenu.route)}
              >
                {subMenu.name === 'Categories'
                  ? 'Products Collections'
                  : subMenu.name === 'Order Process Funnel'
                  ? 'Heat Map'
                  : subMenu.name}
              </SubMenuItem>
            ))}
          </SubMenu>
        )}
    </MenuItemContainer>
  )
}
const MenuItemContainer = styled.li<{ isActive: boolean }>`
  background: ${(props) => (props.isActive ? '#1b1030' : 'transparent')};
`

const MenuLink = styled.div`
  display: flex;
  align-items: center;
  padding: 0.625rem 1.75rem;
  cursor: pointer;
  &:hover {
    background: #1b1030;
  }
`
const SubMenu = styled.ul`
  padding: 0 0 0 40px;
  margin: 0;
  list-style: none;
  background: #090127;
`
const SubMenuItem = styled.li`
  padding: 8px 24px;
  cursor: pointer;
  color: #f8f8f9;
  font-size: 0.813rem;
  font-weight: 400;
  opacity: 0.9;
  &.isActive {
    /* background: #1b1030; */
    color: #9b82fb;
  }
`

export default MenuItem
